<div id="welcome-chart" class="readable">
<p>Unused money is taxed continuously at the rate of 1% per month. It's best to spend or invest the money quickly.</p>
<p>Verified accounts receive M$120,000 yearly, delivered continuously. This chart compares the balance between your unverified account to a verified account over time.</p>
<canvas id="chart-verified-v-unverified" width="600" height="400" style="max-height:400px;"></canvas>
<p>Taxes paid increase as money sits. Even though you receive a continuous deposit, it's also being taxed. It's best to spend or invest.</p>
<p><a href="/" on:click|preventDefault={ ()=> {alert('Coming soon')}}>Want to get verified? </a></p>
</div>

<script>
	export let startingAmt	= 10000

		function generateVerifiedData(months=12) {
			let amount = 0
			let data = []
			for (let i = 0; i < months; i++) {
				amount = amount *.98
				amount += 20000
				data.push(amount)
			}
			return	data
	}
	
	function generateUnverifiedData(months=12) {
			let amount = startingAmt
			let data = []
			for (let i = 0; i < months; i++) {
				amount = amount *.98
				data.push(amount)
			}
			return	data
	}
	
	function generateMonthLabels(months=12) {
		let year = 22
		let labels = []
		let text = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
		for (let i = 0; i < months; i++) {
			labels.push(text[i%12] +	' ' + year)
			if(i%12	== 11) {
				year++
			}
		}
		return labels
	}
		
	function loadChart() {
		
	//var verifiedMonths = verified(0)
	var verifiedData = generateVerifiedData(36)
	var unverifiedData = generateUnverifiedData(36)
	var labels = generateMonthLabels(36)
	
	
			// get the canvas element and its context
			var canvas = document.getElementById('chart-verified-v-unverified');
			var ctx = canvas.getContext('2d');
			
			// define the chart data
			var data = {
					labels: labels,
					datasets: [
							{
									label: 'Unverified',
									borderColor: '#ffff00',
									backgroundColor: 'rgba(255, 255, 0, 0.5)',
	
	data: unverifiedData							},
							{
									label: 'Verified',
									borderColor: '#00ff00',
									backgroundColor: 'rgba(0, 255, 0, 0.5)',
									data: verifiedData
							}
					]
			};
			
			// define the chart options
			var options = {
					responsive: true,
					maintainAspectRatio: false,
					legend: {
							position: 'top',
							labels: {
									fontColor: '#fff',
									fontSize: 18
							}
					},
					scales: {
						y: {type: 'logarithmic'},
							xAxes: [{
									gridLines: {
											color: 'rgba(255, 255, 255, 0.2)'
									},
									ticks: {
											fontColor: '#fff',
											fontSize: 14
									}
							}],
							yAxes: [{
									gridLines: {
											color: 'rgba(255, 255, 255, 0.2)'
									},
									ticks: {
											fontColor: '#fff',
											fontSize: 14
									}
							}]
					}
			};
			
			// create the chart
			var chart = new Chart(ctx, {
					type: 'line',
					data: data,
					options: options
			});
		}

		fetch("https://cdn.jsdelivr.net/npm/chart.js")
  .then((response) => response.text())
  .then((text) => eval(text))
  .then(() => {
    loadChart();
  })
	</script>
	

